import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Receiver events", -1)
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Event Actions"
}
const _hoisted_4 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "List actions"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("button", {
  class: "btn btn-outline-primary",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#filters",
  "aria-expanded": "false",
  "aria-controls": "filters"
}, " Filters ", -1)
const _hoisted_6 = {
  class: "collapse",
  id: "filters",
  role: "toolbar",
  "aria-label": "Event filters"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "initiatorFilter"
}, "Initiator", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "classFilter"
}, "Class", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "conditionFilter"
}, "Condition", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "messageFilter"
}, "Message", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "dataFilter"
}, "Data", -1)
const _hoisted_16 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Filter actions"
}
const _hoisted_17 = { class: "panel" }
const _hoisted_18 = { "aria-label": "Page navigation" }
const _hoisted_19 = { class: "row justify-content-center" }
const _hoisted_20 = { class: "col-sm-2" }
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = {
  key: 0,
  class: "pagination justify-content-center"
}
const _hoisted_23 = {
  key: 1,
  class: "page-link"
}
const _hoisted_24 = { class: "col-sm-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table table-striped" }
const _hoisted_28 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Generated"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Initiator"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Class"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Condition"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Message")
  ])
], -1)
const _hoisted_29 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList())),
          class: "btn btn-outline-primary"
        }, "Refresh"),
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("select", {
          class: "form-select",
          "aria-label": "Initiator",
          "aria-describedby": "initiatorFilter",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestFilter.Initiator = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList()))
        }, [
          _hoisted_9,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions.Initiator, (item) => {
            return (_openBlock(), _createBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.requestFilter.Initiator]
        ]),
        _hoisted_10,
        _withDirectives(_createVNode("select", {
          class: "form-select",
          "aria-label": "Class",
          "aria-describedby": "classFilter",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestFilter.Class = $event)),
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getList()))
        }, [
          _hoisted_11,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions.Class, (item) => {
            return (_openBlock(), _createBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.requestFilter.Class]
        ]),
        _hoisted_12,
        _withDirectives(_createVNode("select", {
          class: "form-select",
          "aria-label": "Condition",
          "aria-describedby": "conditionFilter",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestFilter.Condition = $event)),
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getList()))
        }, [
          _hoisted_13,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions.Condition, (item) => {
            return (_openBlock(), _createBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.requestFilter.Condition]
        ]),
        _hoisted_14,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          "aria-label": "Message",
          "aria-describedby": "messageFilter",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.requestFilter.Message = $event)),
          onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.Message,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_15,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          "aria-label": "Data",
          "aria-describedby": "dataFilter",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.requestFilter.Data = $event)),
          onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.Data,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("button", {
          class: "btn btn-outline-primary",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getList()))
        }, "Apply"),
        _createVNode("button", {
          class: "btn btn-outline-secondary",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearFiltersAndRefresh()))
        }, "Clear")
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("nav", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _withDirectives(_createVNode("select", {
              class: "form-select",
              "aria-label": "Results per page",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.requestPaging.Limit = $event)),
              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getList()))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.requestPaging.Options, (item) => {
                return (_openBlock(), _createBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, ["value"]))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.requestPaging.Limit]
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            (_ctx.pageBounds)
              ? (_openBlock(), _createBlock("ul", _hoisted_22, [
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > _ctx.requestPaging.Limit && _ctx.requestPaging.Skip > 0 ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setPage('-1'))),
                      href: "#",
                      tabindex: "-1",
                      "aria-disabled": "true"
                    }, "Previous")
                  ], 2),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageBounds, (page) => {
                    return (_openBlock(), _createBlock("li", {
                      key: page.number,
                      class: ['page-item', page.current == true ? 'active' : '', page.number == 0 ? 'disabled' : '']
                    }, [
                      (page.number > 0)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "page-link",
                            href: "#",
                            onClick: ($event: any) => (_ctx.setPage(page.number))
                          }, _toDisplayString(page.number), 9, ["onClick"]))
                        : (_openBlock(), _createBlock("a", _hoisted_23, "…"))
                    ], 2))
                  }), 128)),
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > (_ctx.requestPaging.Limit + _ctx.requestPaging.Skip) ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setPage('+1')))
                    }, "Next")
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_24, [
            (_ctx.backendResponse.count > 0)
              ? (_openBlock(), _createBlock("p", _hoisted_25, _toDisplayString(_ctx.requestPaging.Skip > 0 ? _ctx.requestPaging.Skip : 1) + " to " + _toDisplayString(Math.min(_ctx.requestPaging.Skip + _ctx.requestPaging.Limit, _ctx.backendResponse.count)) + " of " + _toDisplayString(_ctx.backendResponse.count), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode("table", _hoisted_27, [
        _hoisted_28,
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backendResponse.items, (event) => {
            return (_openBlock(), _createBlock("tr", {
              key: event.id
            }, [
              _createVNode("td", null, _toDisplayString(_ctx.getHumanDate(event.Generated)), 1),
              _createVNode("td", null, _toDisplayString(event.Initiator), 1),
              _createVNode("td", null, _toDisplayString(event.Class), 1),
              _createVNode("td", null, _toDisplayString(event.Condition), 1),
              _createVNode("td", null, [
                _createTextVNode(_toDisplayString(event.Message), 1),
                (event.Data)
                  ? (_openBlock(), _createBlock("span", _hoisted_29, " (" + _toDisplayString(event.Data) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}